import React from 'react';
export default function Days(_ref) {
  var created = _ref.created;
  var today = new Date();
  var posted = new Date(created);
  var diff = today.getTime() - posted.getTime();
  var days = Math.round(diff / (1000 * 3600 * 24));
  return /*#__PURE__*/React.createElement("span", {
    className: "squeak-post-timestamp"
  }, days <= 0 ? 'Today' : days + " day" + (days === 1 ? '' : 's') + " ago");
}